// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36O8G","left":"styles_left__2yYeI","desktopActions":"styles_desktopActions__ymhEf","title":"styles_title__1KZUh"};